
import * as axiosHelper from "./api_helper";

export const loginUser = async(values) => {
  const data = await axiosHelper.loginApi("/auth/login", values);
  if (data.isError) {
    return data;
  } 
  return data;
};
export const getProfileData = async () => { 
  const data = await axiosHelper.get("/auth/profile");
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};

const toApiError = (result) => {
  const error = new Error(result?.message || "Something went wrong");
  error.type = result?.errors?.type;
  return error;
};

const postOrThrow = async (url, body) => {
  const result = await axiosHelper.post(url, body);
  if (result.isError) throw toApiError(result);
  return result;
};

export const verifyCodeAPI = ({ mfaToken, code }) => postOrThrow("/auth/verify_otp", {
  mfaToken,
  code,
});

export const startTwoFactorSetupAPI = ({ mfaToken }) => postOrThrow("/auth/2fa/setup/qr", { mfaToken });
export const completeTwoFactorSetupAPI = ({ mfaToken, code }) => postOrThrow("/auth/2fa/setup/verify", {
  mfaToken,
  code,
});

export const enableTwoFactorAPI = ({ code }) => postOrThrow("/auth/2fa/enable", { code });
export const disableTwoFactorAPI = ({ code, password }) => postOrThrow("/auth/2fa/disable", {
  code,
  password,
});

export const logoutAPI = async () => {
  try {
    return await axiosHelper.post("/auth/logout", {});
  } catch (error) {
    return null;
  }
};

export const generateQRCodeAPI = async ()=>{
  const result = await axiosHelper.get("/auth/generateQR");
  if (result.isError)
    throw new Error(result.message);
  else return result;
};